import definition from './alerts-actions.service';

/**
 * AlertsActionsApi settings
 * @type {{name: string, definition: AlertsActionsApi}}
 */
export default {
    name: 'AlertsActionsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/alerts-actions/index.js